export default "__VITE_ASSET__jQtCyh7___"